import { products } from '../data/products'
import type { Tone } from '../types/snak'

/** First step that introduces a product. */
export const PRODUCT_START = 4
/** The "no best sibling" payoff. */
export const POINT_STEP = PRODUCT_START + products.length
/** The closing screen. */
export const CLOSE_STEP = POINT_STEP + 1
export const TOTAL_STEPS = CLOSE_STEP + 1

export function toneForStep(step: number, interludeDark: boolean): Tone {
  if (step <= 1) return 'light'
  if (step === 2) return interludeDark ? 'dark' : 'light'
  return 'dark'
}
